export const getUseQueryHookState = <
  T extends { isLoading: boolean; isError: boolean },
>(
  state: 'isLoading' | 'isError' | 'isSuccess' | 'isFetching',
  hooksResults: T[],
  method: 'some' | 'every' = 'some',
) => hooksResults[method](result => result[state]);
